import { createSlice } from '@reduxjs/toolkit';
import { service } from '../shared/_services/api_service';
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  applicationsData: [],
  totalApplications: 0,
  selectedApplication: null,
};

export const teacherApplicationsSlice = createSlice({
  name: "teacherApplications",
  initialState,
  reducers: {
    setTeacherApplicationsData(state, { payload }) {
      state.applicationsData = payload.result;
      state.totalApplications = payload.total;
    },
    updateTeacherApplicationData(state, { payload }) {
      const objIndex = state.applicationsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.applicationsData[objIndex] = payload;
      }
      if (state.selectedApplication && state.selectedApplication._id === payload._id) {
        state.selectedApplication = payload;
      }
    },
    setSelectedApplication(state, { payload }) {
      state.selectedApplication = payload;
    }
  }
});

export const {
  setTeacherApplicationsData,
  updateTeacherApplicationData,
  setSelectedApplication
} = teacherApplicationsSlice.actions;

export default teacherApplicationsSlice.reducer;

export function getTeacherApplications(limit = 30, offset = 0, keyword = '', startDate = '', endDate = '') {
  return async function getTeacherApplicationsThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.getTeacherApplications(limit, offset, keyword, startDate, endDate);
      dispatch(setTeacherApplicationsData({
        result: response.data?.result || [],
        total: response.data?.count || 0
      }));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}

export function updateTeacherApplicationStatus(id, status) {
  return async function updateTeacherApplicationStatusThunk(dispatch) {
    dispatch(setLoading(true));
    try {
      const response = await service.updateTeacherApplicationStatus(id, status);
      dispatch(updateTeacherApplicationData(response.data));
      dispatch(setLoading(false));
      successHandler('Status Updated Successfully');
    } catch (error) {
      dispatch(setLoading(false));
      if (error && error.response) {
        errorHandler(error.response);
      }
    }
  };
}
